import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import { TextField, Typography, Box, Alert } from '@mui/material';
import { isEmailInvalid } from '../../helpers/general.helpers';

export interface TransferEquipmentOwnershipDialogProps {
  isOpen: boolean;
  equipmentName?: string;
  handleClose: any;
  handleSubmit: any;
  isLoading: boolean;
}

export default function TransferEquipmentOwnershipDialog(props: TransferEquipmentOwnershipDialogProps) {
  const [ownerEmail, setOwnerEmail] = useState<string>('');
  const [ownerEmailError, setOwnerEmailError] = useState<string>('');

  const closeModal = () => {
    setOwnerEmail('');
    setOwnerEmailError('');
    props.handleClose();
  };

  const submit = () => {
    setOwnerEmailError('');
    if (isEmailInvalid(ownerEmail)) {
      setOwnerEmailError('This email is invalid. Please use a valid email');
    } else {
      const email = ownerEmail;
      setOwnerEmail('');
      props.handleSubmit(email);
    }
  };

  return (
    <Dialog open={props.isOpen} onClose={closeModal}>
      <DialogTitle>Transfer Equipment Ownership</DialogTitle>
      <DialogContent style={{ display: 'flex', minWidth: 600, flexDirection: 'column' }}>
        {props.equipmentName && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
              This will transfer ownership of:
            </Typography>
            <Typography variant="subtitle2">{props.equipmentName}</Typography>
          </Box>
        )}
        <TextField
          label="New Owner Email"
          name="newOwnerEmail"
          value={ownerEmail}
          variant="outlined"
          size="small"
          margin="normal"
          onChange={(evt) => setOwnerEmail(evt.target.value)}
          helperText={
            ownerEmailError.length > 1
              ? ownerEmailError
              : 'Type in the email of the user you would like to transfer ownership to. Click submit to send the invitation'
          }
          error={ownerEmailError.length > 1}
        />
        <Alert severity="info" sx={{ mt: 2 }}>
          Note: If accepted, you will become a manager of this equipment.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="error">
          Cancel
        </Button>
        <Button onClick={submit} disabled={props.isLoading}>
          Send Invitation
        </Button>
      </DialogActions>
    </Dialog>
  );
}
